(() => {
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  class SeasonSection extends HTMLElement {
    connectedCallback() {
      this.controller?.abort(); this.controller = new AbortController();
      const signal = this.controller.signal;
      if (this.dataset.reveal === 'true' && !reduced() && !window.Shopify?.designMode && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => entries.forEach(entry => {
          if (entry.isIntersecting) { entry.target.classList.remove('gs-await'); entry.target.classList.add('gs-visible'); this.observer.unobserve(entry.target); }
        }), {threshold: .07});
        this.querySelectorAll('[data-gs-reveal]').forEach(el => { if (el.getBoundingClientRect().top > innerHeight - 30) { el.classList.add('gs-await'); this.observer.observe(el); } });
      }
      this.addEventListener('shopify:block:select', event => {
        const details = event.target.closest('details');
        if (details) details.open = true;
      }, {signal});
    }
    disconnectedCallback(){this.observer?.disconnect();this.controller?.abort();}
  }
  class SeasonSlider extends HTMLElement {
    connectedCallback() {
      this.controller?.abort(); this.controller = new AbortController(); const signal=this.controller.signal;
      this.track=this.querySelector('.gs-slides');this.slides=[...this.querySelectorAll('.gs-slide')];this.tabs=[...this.querySelectorAll('[data-slide]')];this.index=0;this.elapsed=0;this.hovered=false;
      if(!this.track || !this.slides.length)return;
      if(this.dataset.randomStart==='true'&&!window.Shopify?.designMode){
        const candidates=this.slides.map((slide,index)=>slide.dataset.startCandidate==='true'?index:-1).filter(index=>index>=0);
        if(candidates.length)this.index=candidates[Math.floor(Math.random()*candidates.length)];
      }
      this.track.scrollTo({left:this.index*this.track.clientWidth,behavior:'instant'});
      this.duration=Number(this.dataset.interval||8)*1000;
      this.querySelector('[data-slider-controls]').hidden=this.slides.length<2;
      this.playing=this.dataset.autoplay==='true'&&!reduced()&&!window.Shopify?.designMode;
      this.querySelector('[data-pause]')?.addEventListener('click',()=>{this.playing=!this.playing;this.timerUpdate();},{signal});
      this.tabs.forEach(tab=>tab.addEventListener('click',()=>{this.playing=false;this.go(Number(tab.dataset.slide));},{signal}));
      this.track.addEventListener('keydown',event=>{
        if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();this.playing=false;this.go(this.index+(event.key==='ArrowRight'?1:-1));}
      },{signal});
      this.track.addEventListener('scroll',()=>{
        cancelAnimationFrame(this.scrollFrame);this.scrollFrame=requestAnimationFrame(()=>{
          const index=Math.round(this.track.scrollLeft/this.track.clientWidth);
          if(index!==this.index){this.index=index;this.elapsed=0;this.paint();this.timerUpdate();}
        });
      },{passive:true,signal});
      this.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse'){this.hovered=true;this.timerUpdate();}},{signal});
      this.addEventListener('pointerleave',()=>{this.hovered=false;this.timerUpdate();},{signal});
      this.addEventListener('focusin',event=>{if(!event.target.closest('[data-pause]')){this.playing=false;this.timerUpdate();}},{signal});
      this.track.addEventListener('pointerdown',()=>{this.playing=false;this.timerUpdate();},{signal});
      this.addEventListener('shopify:block:select',event=>{
        const i=this.slides.findIndex(slide=>slide===event.target||slide.contains(event.target));
        if(i>=0){this.playing=false;this.go(i);}
      },{signal});
      document.addEventListener('visibilitychange',()=>this.timerUpdate(),{signal});
      window.matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change',()=>{if(reduced())this.playing=false;this.timerUpdate();},{signal});
      this.dataset.ready='true';
      this.resize=new ResizeObserver(()=>{this.track.scrollTo({left:this.index*this.track.clientWidth,behavior:'instant'});this.measureHeight();});this.resize.observe(this.track);this.slides.forEach(slide=>this.resize.observe(slide));
      this.paint();this.timerUpdate();
    }
    go(index){this.index=(index+this.slides.length)%this.slides.length;this.elapsed=0;this.track.scrollTo({left:this.index*this.track.clientWidth,behavior:'instant'});this.paint();this.timerUpdate();}
    paint(){
      this.tabs.forEach((tab,i)=>tab.setAttribute('aria-current',String(i===this.index)));
      this.slides.forEach((slide,i)=>{slide.inert=i!==this.index;slide.setAttribute('aria-hidden',String(i!==this.index));});
      this.measureHeight();this.progress();
    }
    measureHeight(){const height=this.slides[this.index]?.getBoundingClientRect().height;if(height)this.style.setProperty('--gs-active-height',Math.ceil(height)+'px');}
    progress(){this.style.setProperty('--gs-slide-progress',(this.playing?Math.min(100,this.elapsed/this.duration*100):100)+'%');}
    timerUpdate(){
      cancelAnimationFrame(this.timer);this.lastTick=null;
      const pause=this.querySelector('[data-pause]');
      if(pause){pause.hidden=this.slides.length<2;pause.textContent=this.playing?'Pausa bildspelet':'Spela bildspelet';pause.setAttribute('aria-label',pause.textContent);}
      this.progress();
      if(!this.playing||this.hovered||document.hidden||reduced()||this.slides.length<2)return;
      const tick=now=>{
        if(this.lastTick!==null)this.elapsed+=now-this.lastTick;
        this.lastTick=now;this.progress();
        if(this.elapsed>=this.duration){this.go(this.index+1);return;}
        this.timer=requestAnimationFrame(tick);
      };
      this.timer=requestAnimationFrame(tick);
    }
    disconnectedCallback(){cancelAnimationFrame(this.timer);cancelAnimationFrame(this.scrollFrame);this.resize?.disconnect();this.controller?.abort();}
  }
  class SeasonRecipes extends HTMLElement {
    connectedCallback(){
      this.controller?.abort();this.controller=new AbortController();const signal=this.controller.signal;
      this.track=this.querySelector('.gs-recipe-grid');this.cards=[...this.querySelectorAll('.gs-recipe')];
      this.controls=this.querySelector('[data-recipe-controls]');this.prev=this.querySelector('[data-recipe-prev]');this.next=this.querySelector('[data-recipe-next]');
      if(!this.track||!this.cards.length)return;
      this.prev.addEventListener('click',()=>this.move(-1),{signal});
      this.next.addEventListener('click',()=>this.move(1),{signal});
      this.track.addEventListener('pointerdown',()=>{this.destination=null;},{passive:true,signal});
      this.track.addEventListener('wheel',()=>{this.destination=null;},{passive:true,signal});
      this.track.addEventListener('scroll',()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>this.paint());},{passive:true,signal});
      this.track.addEventListener('keydown',event=>{
        if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
        event.preventDefault();
        const focused=this.cards.indexOf(event.target.closest('.gs-recipe'));
        if(focused>=0){
          const index=event.key==='Home'?0:event.key==='End'?this.cards.length-1:Math.max(0,Math.min(this.cards.length-1,focused+(event.key==='ArrowRight'?1:-1)));
          this.cards[index].focus({preventScroll:true});this.go(index);
        }else if(event.key==='Home')this.go(0);else if(event.key==='End')this.go(this.cards.length-1);else this.move(event.key==='ArrowRight'?1:-1);
      },{signal});
      this.addEventListener('shopify:block:select',event=>{const i=this.cards.findIndex(card=>card===event.target||card.contains(event.target));if(i>=0)this.go(i,true);},{signal});
      this.resize=new ResizeObserver(()=>{this.measure();this.go(this.index||0,true);});
      this.resize.observe(this.track);this.measure();this.paint();
    }
    measure(){
      this.maximum=Math.max(0,this.track.scrollWidth-this.track.clientWidth);
      const first=this.cards[0].offsetLeft;
      this.positions=this.cards.map(card=>Math.min(this.maximum,card.offsetLeft-first));
      this.controls.hidden=this.maximum<2;
      const image=this.cards[0].querySelector('.gs-recipe-image');
      this.style.setProperty('--gs-recipe-arrow-top',(image.getBoundingClientRect().height/2)+'px');
    }
    paint(){
      if(this.destination!=null&&Math.abs(this.destination-this.track.scrollLeft)<2)this.destination=null;
      if(this.destination==null)this.index=this.positions.reduce((best,left,i)=>Math.abs(left-this.track.scrollLeft)<Math.abs(this.positions[best]-this.track.scrollLeft)?i:best,0);
      this.prev.disabled=this.track.scrollLeft<2;this.next.disabled=this.track.scrollLeft>=this.maximum-2;
    }
    go(index,instant=false){
      this.index=Math.max(0,Math.min(this.cards.length-1,index));
      this.destination=this.positions[this.index];
      this.track.scrollTo({left:this.destination,behavior:instant||reduced()?'instant':'smooth'});
    }
    move(direction){
      const current=this.destination??this.track.scrollLeft;
      const target=direction>0?this.positions.findIndex(left=>left>current+2):this.positions.findLastIndex(left=>left<current-2);
      if(target>=0)this.go(target);
    }
    disconnectedCallback(){cancelAnimationFrame(this.frame);this.resize?.disconnect();this.controller?.abort();}
  }
  class SeasonProducts extends HTMLElement {
    connectedCallback(){
      this.controller?.abort();this.controller=new AbortController();
      const button=this.querySelector('[data-expand-products]');
      if(!button)return;
      const extra=[...this.querySelectorAll('[data-extra-product]')];
      extra.forEach(item=>item.hidden=true);button.hidden=extra.length===0;
      button.addEventListener('click',()=>{
        const next=extra.filter(item=>item.hidden).slice(0,24);
        next.forEach(item=>item.hidden=false);button.hidden=!extra.some(item=>item.hidden);
        if(button.hidden&&next.length)next[0].querySelector('a')?.focus({preventScroll:true});
      },{signal:this.controller.signal});
    }
    disconnectedCallback(){this.controller?.abort();}
  }
  class SeasonQuiz extends HTMLElement {
    connectedCallback(){
      clearTimeout(this.expiryTimer);this.refreshingExpiry=false;
      this.controller?.abort();this.controller=new AbortController();const signal=this.controller.signal;
      this.entrySending=false;
      this.bindEntryForm(signal);
      this.questions=[...this.querySelector('template[data-questions]').content.querySelectorAll('[data-question]')];
      if(!this.questions.length)return;
      this.index=0;this.answers=Array(this.questions.length).fill(null);this.locked=Array(this.questions.length).fill(false);
      this.competition=['giveaway','preview'].includes(this.querySelector('[data-prize]')?.dataset.mode);
      this.panel=this.querySelector('[data-quiz-panel]');this.result=this.querySelector('[data-quiz-result]');this.questionSlot=this.querySelector('[data-question-slot]');
      this.panel.hidden=false;
      this.addEventListener('click',event=>{
        const button=event.target.closest('button');if(!button)return;
        if(button.hasAttribute('data-answer')&&!this.locked[this.index]){
          this.answers[this.index]=Number(button.dataset.answer);this.questionSlot.querySelectorAll('[data-answer]').forEach(answer=>answer.setAttribute('aria-pressed',String(answer===button)));
          this.querySelector('[data-check]').disabled=false;
        }
        if(button.hasAttribute('data-check'))this.check();
        if(button.hasAttribute('data-next-question')){if(this.index<this.questions.length-1){this.index++;this.render(true);}else this.finish();}
        if(button.hasAttribute('data-back-question')&&this.index>0){this.index--;this.render(true);}
        if(button.hasAttribute('data-restart')){this.index=0;this.answers.fill(null);this.locked.fill(false);this.entryResponse=null;this.result.hidden=true;this.panel.hidden=false;this.render(true);this.prizeState();}
      },{signal});
      document.addEventListener('shopify:block:select',event=>{
        if(event.detail?.sectionId!==this.dataset.sectionId)return;
        const id=event.detail?.blockId;const i=this.questions.findIndex(q=>q.dataset.blockId===id);
        if(i>=0){this.index=i;this.result.hidden=true;this.panel.hidden=false;this.render(false);}
      },{signal});
      this.entryResponse=this.querySelector('[data-entry-response]')?.dataset.entryResponse;
      this.render(false);
      if(this.entryResponse&&(this.competition||this.entryResponse==='success')){
        this.panel.hidden=true;this.result.hidden=false;this.querySelector('[data-score]').hidden=true;this.querySelector('[data-result-message]').textContent='';
        this.querySelector('[data-restart]').hidden=this.entryResponse==='success';
      }
      this.prizeState();
      this.syncExpiry();
      this.revealEntryResponse();
      document.addEventListener('visibilitychange',()=>{if(!document.hidden){this.prizeState();this.syncExpiry();}},{signal});
    }
    bindEntryForm(signal){
      this.entryForm=this.querySelector('.gs-quiz-entry');
      if(this.hasAttribute('data-theme-editor')||window.Shopify?.designMode===true){
        const blockEntry=event=>{
          event.preventDefault();event.stopImmediatePropagation();
          this.querySelector('[data-entry-editor-notice]')?.focus({preventScroll:true});
        };
        const button=this.querySelector('[data-entry-submit]');
        if(button){button.type='button';button.addEventListener('click',blockEntry,{capture:true,signal});}
        this.entryForm?.addEventListener('submit',blockEntry,{capture:true,signal});
        return;
      }
      this.entryForm?.addEventListener('submit',event=>{
        event.preventDefault();
        if(this.entrySending||this.entryResponse==='success')return;
        if(!this.prizeState()||!this.locked.every(Boolean)&&this.entryResponse!=='error'){
          const status=this.querySelector('[data-prize-status]');status.textContent=this.querySelector('[data-prize]').dataset.contactClosed;return;
        }
        if(this.entryForm.reportValidity())this.sendEntry();
      },{signal});
    }
    entryEndpoint(){
      try{
        const endpoint=new URL(this.entryForm?.dataset.entryEndpoint||'');
        return endpoint.protocol==='https:'&&endpoint.hostname==='script.google.com'&&/^\/macros\/s\/[A-Za-z0-9_-]+\/exec$/.test(endpoint.pathname)&&!endpoint.search&&!endpoint.hash?endpoint.href:null;
      }catch{return null;}
    }
    async sendEntry(){
      const form=this.entryForm,endpoint=this.entryEndpoint();
      if(!endpoint||!this.locked.every(Boolean))return;
      const status=form.querySelector('[data-entry-send-status]'),fields=form.querySelector('[data-entry-fields]');
      const values=new FormData(form),prize=this.querySelector('[data-prize]');
      const payload={
        name:String(values.get('entry_name')||'').trim(),email:String(values.get('entry_email')||'').trim(),
        consent:values.has('entry_consent'),website:String(values.get('entry_website')||''),
        quiz:{startsAt:prize.dataset.start,endsAt:prize.dataset.end,questions:this.questions.map(q=>({
          id:q.dataset.blockId,prompt:q.querySelector('h3').textContent.trim(),
          options:[...q.querySelectorAll('[data-answer-label]')].map(a=>a.textContent.trim())
        }))},answers:[...this.answers]
      };
      const fingerprint=JSON.stringify(payload);
      // Keep the same receipt for a retry, but not for changed entry details.
      if(this.entryAttempt?.fingerprint!==fingerprint)this.entryAttempt={fingerprint,requestId:crypto.randomUUID()};
      payload.requestId=this.entryAttempt.requestId;
      this.entrySending=true;fields.disabled=true;form.setAttribute('aria-busy','true');
      status.hidden=false;status.textContent=form.dataset.sending;
      const request=new AbortController(),signal=this.controller.signal;
      const cancel=()=>request.abort();signal.addEventListener('abort',cancel,{once:true});
      const timer=setTimeout(cancel,45000);
      try{
        const response=await fetch(endpoint,{method:'POST',credentials:'omit',redirect:'follow',
          headers:{'Content-Type':'text/plain;charset=UTF-8'},body:JSON.stringify(payload),signal:request.signal});
        if(!response.ok)throw new Error('retry');
        const result=await response.json();
        if(result.ok!==true||result.requestId!==payload.requestId)throw new Error(result.code||'retry');
        if(signal.aborted||!this.isConnected)return;
        this.entryResponse='success';fields.hidden=true;status.hidden=true;
        const success=form.querySelector('[data-entry-success]');success.hidden=false;
        success.dataset.entryResponse='success';success.focus({preventScroll:true});
        this.querySelector('[data-restart]').hidden=true;
        this.prizeState();
        // Keep the visitor at the form; scroll only if the confirmation is outside the viewport.
        const rect=success.getBoundingClientRect();
        if(rect.top<0||rect.bottom>window.innerHeight)success.scrollIntoView({block:'center',behavior:reduced()?'instant':'smooth'});
      }catch(error){
        if(signal.aborted||!this.isConnected)return;
        status.hidden=false;
        status.textContent=error.message==='closed'?form.dataset.sendClosed:error.message==='outdated'?form.dataset.sendOutdated:form.dataset.sendError;
        status.focus({preventScroll:true});
      }finally{
        clearTimeout(timer);signal.removeEventListener('abort',cancel);
        if(!signal.aborted){this.entrySending=false;form.removeAttribute('aria-busy');this.prizeState();}
      }
    }
    revealEntryResponse(){
      const response=this.querySelector('[data-entry-response]');
      if(!response||!['success','error'].includes(this.entryResponse)||this.result.hidden)return;
      const signal=this.controller.signal;
      let interrupted=false;
      const stop=()=>{interrupted=true;};
      for(const type of ['pointerdown','touchstart','wheel','keydown'])window.addEventListener(type,stop,{once:true,passive:true,signal});
      const position=()=>{
        requestAnimationFrame(()=>{
          if(signal.aborted||interrupted||!response.isConnected||response.closest('[hidden]'))return;
          response.focus({preventScroll:true});
          response.scrollIntoView({block:'center',behavior:'instant'});
        });
      };
      position();
      if(document.readyState!=='complete')window.addEventListener('load',position,{once:true,signal});
      document.fonts?.ready.then(position);
    }
    render(focus){
      this.questionSlot.replaceChildren(this.questions[this.index].cloneNode(true));
      this.querySelector('[data-count]').textContent='Fråga '+(this.index+1)+' av '+this.questions.length;
      const progress=this.querySelector('progress');progress.max=this.questions.length;progress.value=this.locked.filter(Boolean).length;
      this.querySelector('[data-back-question]').disabled=this.index===0;
      const check=this.querySelector('[data-check]'),next=this.querySelector('[data-next-question]');
      const last=this.index===this.questions.length-1;
      const nextLabel=this.competition?(last?this.dataset.competitionFinish:this.dataset.competitionNext):(last?'Se mitt resultat':'Nästa fråga');
      const checkLabel=check.querySelector('[data-check-label]');if(checkLabel)checkLabel.textContent=this.competition?nextLabel:(this.dataset.knowledgeCheck||checkLabel.textContent);
      check.hidden=this.locked[this.index];check.disabled=this.answers[this.index]===null;next.hidden=!this.locked[this.index];next.querySelector('[data-next-label]').textContent=nextLabel;
      this.questionSlot.querySelectorAll('[data-answer]').forEach(btn=>{btn.setAttribute('aria-pressed',String(Number(btn.dataset.answer)===this.answers[this.index]));btn.disabled=this.locked[this.index];});
      if(this.locked[this.index]&&!this.competition)this.feedback();
      if(focus)this.focusHeading(this.questionSlot.querySelector('h3'));
    }
    focusHeading(heading){
      heading.focus({preventScroll:true});
      const headerHeight=parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height'))||0;
      const safeTop=headerHeight+24;
      if(heading.getBoundingClientRect().top<safeTop){
        heading.style.scrollMarginTop=safeTop+'px';
        heading.scrollIntoView({block:'start',behavior:'instant'});
      }
    }
    check(){
      if(this.answers[this.index]===null||this.locked[this.index])return;
      this.locked[this.index]=true;
      if(this.competition){if(this.index<this.questions.length-1){this.index++;this.render(true);}else this.finish();return;}
      this.render(false);this.querySelector('[data-feedback]')?.focus({preventScroll:true});
    }
    feedback(){
      if(this.competition)return;
      const right=Number(this.questions[this.index].dataset.correct)-1;
      const el=this.questionSlot.querySelector('[data-feedback]');el.hidden=false;
      el.querySelector('[data-verdict]').textContent=this.answers[this.index]===right?'Rätt!':'Inte riktigt. Rätt svar: '+this.questions[this.index].querySelector('[data-answer="'+right+'"] [data-answer-label]').textContent.trim();
    }
    finish(focus=true){
      if(!this.locked.every(Boolean))return;
      this.panel.hidden=true;this.result.hidden=false;
      const scoreField=this.querySelector('[data-score]'),message=this.querySelector('[data-result-message]');scoreField.hidden=this.competition;scoreField.textContent='';
      if(this.competition){message.textContent=this.dataset.competitionComplete;}
      else{
        const score=this.answers.reduce((sum,answer,i)=>sum+(answer===Number(this.questions[i].dataset.correct)-1?1:0),0);
        scoreField.textContent=score+' / '+this.questions.length;
        message.textContent=score>=this.questions.length*.8?'Du har god känsla för långkok och ugn. Dags att låta kunskapen ta plats i köket!':score>=this.questions.length*.5?'Du har flera goda köksknep med dig. Nu har du också några nya att prova.':'Varje fråga är ett nytt köksknep. Ta med dig tipsen och prova något gott i helgen.';
      }
      this.prizeState();if(focus)this.focusHeading(this.result.querySelector('h3'));
    }
    fillEntryAnswers(){
      const field=this.querySelector('[data-entry-answers]');if(!field)return;
      field.value=this.questions.map((q,i)=>(i+1)+'. '+q.querySelector('h3').textContent.trim()+'\n'+q.querySelector('[data-answer="'+this.answers[i]+'"] [data-answer-label]').textContent.trim()).join('\n\n');
    }
    prizeState(){
      const prize=this.querySelector('[data-prize]');if(!prize)return;
      const mode=prize.dataset.mode,start=Date.parse(prize.dataset.start),end=Date.parse(prize.dataset.end),now=Date.now();
      const link=prize.querySelector('[data-entry]'),status=prize.querySelector('[data-prize-status]');
      const form=prize.querySelector('[data-entry-form]'),fields=prize.querySelector('[data-entry-fields]'),internal=['contact','sheets'].includes(prize.dataset.entryMethod);
      const terms=prize.querySelector('[data-terms]');
      const configured=Number.isFinite(start)&&Number.isFinite(end)&&end>start&&(internal?form:link?.getAttribute('href'))&&(prize.dataset.entryMethod!=='sheets'||this.entryEndpoint())&&(terms?.getAttribute('href')||terms?.textContent?.trim());
      if(link)link.hidden=true;
      if(form)form.hidden=true;if(fields)fields.disabled=true;
      if(mode==='knowledge'&&this.entryResponse!=='success'){prize.hidden=true;return;}
      prize.hidden=false;
      if(internal&&this.entryResponse==='success'){if(form)form.hidden=false;status.textContent='';return;}
      if(internal&&this.entrySending){if(form)form.hidden=false;status.textContent='';return;}
      if(mode==='preview'){status.textContent='Exempel inför höstkampanjen. Utlottningen är inte öppen och inget deltagande registreras.';return;}
      if(!configured){status.textContent='Utlottningen är inte öppen ännu.';return;}
      if(now<start){status.textContent='Utlottningen öppnar '+new Date(start).toLocaleDateString('sv-SE')+'.';return;}
      if(now>=end){status.textContent='Utlottningen är avslutad. Du kan fortfarande göra quizet och lära dig nya köksknep.';return;}
      if(internal){
        status.textContent=prize.dataset.contactOpen;
        const ready=this.locked.every(Boolean)||this.entryResponse==='error';
        if(form)form.hidden=!ready;if(fields)fields.disabled=!ready;
        if(ready&&this.entryResponse!=='error')this.fillEntryAnswers();
        return ready;
      }
      status.textContent='Quizet är klart! För att delta behöver du även skicka in din anmälan. Öppet till '+new Date(end).toLocaleDateString('sv-SE')+'.';
      if(link)link.hidden=false;
      return true;
    }
    syncExpiry(){
      clearTimeout(this.expiryTimer);
      const prize=this.querySelector('[data-prize]');
      if(!this.competition||prize?.dataset.mode!=='giveaway')return;
      const start=Date.parse(prize.dataset.start),end=Date.parse(prize.dataset.end);
      if(!Number.isFinite(start)||!Number.isFinite(end)||end<=start)return;
      const remaining=end-Date.now();
      if(remaining>0){this.expiryTimer=setTimeout(()=>this.syncExpiry(),Math.min(remaining,2147483647));return;}
      this.prizeState();
      if(this.refreshingExpiry)return;
      this.refreshingExpiry=true;
      const notice=this.querySelector('[data-quiz-mode-status]');
      if(notice){notice.hidden=false;notice.textContent=this.dataset.expiryLoading;}
      this.loadKnowledgeMode();
    }
    async loadKnowledgeMode(){
      const signal=this.controller.signal;
      try{
        const url=new URL(window.location.href);url.hash='';
        url.searchParams.set('section_id',this.dataset.sectionId);url.searchParams.set('_quiz_refresh',String(Date.now()));
        const response=await fetch(url,{cache:'no-store',credentials:'same-origin',signal});
        if(!response.ok)throw new Error('Quiz section unavailable');
        const documentNew=new DOMParser().parseFromString(await response.text(),'text/html');
        if(signal.aborted)return;
        const fresh=[...documentNew.querySelectorAll('gg-season-quiz')].find(q=>q.dataset.sectionId===this.dataset.sectionId);
        const prize=this.querySelector('[data-prize]'),freshPrize=fresh?.querySelector('[data-prize]');
        const template=fresh?.querySelector('template[data-questions]');
        const questions=[...(template?.content.querySelectorAll('[data-question]')||[])];
        if(freshPrize?.dataset.mode!=='knowledge'||freshPrize.dataset.end!==prize.dataset.end||questions.length!==this.questions.length||questions.some((q,i)=>q.dataset.blockId!==this.questions[i].dataset.blockId||!['1','2','3'].includes(q.dataset.correct)||!q.querySelector('[data-feedback]')))throw new Error('Knowledge mode not available yet');
        const target=this.querySelector('template[data-questions]');target.content.replaceChildren(document.importNode(template.content,true));
        this.questions=[...target.content.querySelectorAll('[data-question]')];this.competition=false;prize.dataset.mode='knowledge';
        const intro=this.closest('.gs-quiz-layout')?.querySelector('[data-quiz-intro]'),freshIntro=fresh.closest('.gs-quiz-layout')?.querySelector('[data-quiz-intro]');
        if(intro&&freshIntro)intro.textContent=freshIntro.textContent;
        const notice=this.querySelector('[data-quiz-mode-status]');
        if(notice){notice.hidden=false;notice.textContent=fresh.querySelector('[data-quiz-mode-status]')?.textContent||'';}
        this.render(false);
        if(this.entryResponse!=='success'){
          this.entryResponse=null;
          if(this.locked.every(Boolean))this.finish(false);
          else{this.result.hidden=true;this.panel.hidden=false;}
        }
        this.prizeState();
      }catch(error){
        if(signal.aborted)return;
        const notice=this.querySelector('[data-quiz-mode-status]');if(notice)notice.textContent=this.dataset.expiryRetry;
        this.expiryTimer=setTimeout(()=>this.syncExpiry(),30000);
      }finally{if(!signal.aborted)this.refreshingExpiry=false;}
    }
    disconnectedCallback(){clearTimeout(this.expiryTimer);this.controller?.abort();}
  }
  for(const [name,constructor] of [['gg-season-section',SeasonSection],['gg-season-slider',SeasonSlider],['gg-season-recipes',SeasonRecipes],['gg-season-products',SeasonProducts],['gg-season-quiz',SeasonQuiz]])if(!customElements.get(name))customElements.define(name,constructor);
})();
